import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import makeRequest from 'utils/makeRequest';
import Link from 'components/Link';
import Image from 'components/Image';
import InViewObserver from 'components/InViewObserver';
import Slider from 'react-slick';
import InterSectionBorder from 'components_v2/common/InterSectionBorder';
import RenderAds from '../../../routes/home/components/desktop/RenderAds';
import Listingheader from '../../../routes/home/components/common/ListingheaderV2';
import s from './BannerSlider.scss';

const PrevArrow = sliderProps => {
  const { className } = sliderProps;
  return (
    <button {...sliderProps} className={`${s.arrows} ${s.left} ${className}`} />
  );
};

const NextArrow = sliderProps => {
  const { className } = sliderProps;
  return (
    <button
      {...sliderProps}
      className={`${s.arrows} ${s.right} ${className}`}
    />
  );
};

class BannerSlider extends React.Component {
  constructor() {
    super();
    this.state = {};
  }
  // componentDidMount() {
  //   const { data = {}, onRendered } = this.props;
  //   if (data && data.dataUrl) {
  //     this.loadSectionData(data.dataUrl, onRendered);
  //   }
  // }

  loadSliderData = () => {
    const { data = {}, onRendered } = this.props;
    if (data && data.dataUrl) {
      this.loadSectionData(data.dataUrl, onRendered);
    }
  };

  loadSectionData = (dataUrl, cb) => {
    if (!dataUrl) {
      return;
    }

    makeRequest
      .get(dataUrl, { isMobile: this.props.isMobile }, 'skipfeedengine')
      .then(data => {
        if (
          data &&
          data.data &&
          data.data.items &&
          data.data.items.length > 0
        ) {
          this.setState(
            {
              data: { ...this.props.data, ...data.data },
            },
            cb,
          );
        }
      });
  };

  render() {
    const { sliderSetting, gaAction, gaLabelPerfix } = this.props;

    const data = this.state.data || this.props.data;

    const bannerWidth = data.bannerWidth || this.props.bannerWidth;
    const className = data.className || this.props.className;
    let showHeading = false;
    let ubannerWidth = bannerWidth;
    let classWrapper = '';
    if (
      data &&
      data.items &&
      data.items.length > 0 &&
      data.items[0]?.tn &&
      data.items[0]?.tn !== 'ad'
    ) {
      showHeading = true;
    }
    if (!showHeading && data.id === 'spotlight_banner_widget') {
      showHeading = true;
      classWrapper = s.sectionwithad;
      ubannerWidth = 300;
    }
    // if (!(data && Array.isArray(data.items) && data.items.length > 0)) {
    //   return null;
    // }

    const scrollGAAttr = {
      ...(data.onScrollGA && data.id && { 'data-scrollga': data.id }),
    };
    const settings = {
      slidesToShow: data?.slidesToShow || 3,
      slidesToScroll: 1,
      variableWidth: true,
      arrows: true,
      dots: true,
      infinite: false,
      dotsClass: s.dots,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: data?.slidesToShow || 3,
          },
        },
      ],
      ...sliderSetting,
    };

    const doNotLazyLoadBanners = data && data.id === 'election_banner_widget';

    return (
      <InViewObserver
        inViewCallback={() => {
          this.loadSliderData();
        }}
        className={classWrapper}
        viewMargin="300px 0px 300px 0px"
      >
        {data &&
          Array.isArray(data.items) &&
          data.items.length > 0 && (
            <>
              {data.border && data.border === 'top' && <InterSectionBorder />}
              <div
                className={`${s.bannerSlider} ${className}`}
                {...scrollGAAttr}
              >
                <div className={s.sliderBlk}>
                  {!showHeading && (
                    <div className="grid_wrapper">
                      {data.items.map(obj => (
                        <RenderAds
                          adObject={obj}
                          adWrapperClassname="col_l_4 col_m_4"
                        />
                      ))}
                    </div>
                  )}
                  {showHeading && (
                    <>
                      <Listingheader
                        headingname={data.name}
                        headingLink={data.path}
                        newga={`${data.name}Section_Actions#HeadingClick`}
                        ga4Type={data?.ga4Type}
                      />
                      <div className={`slick_UI ${s.slider_wrapper}`}>
                        <Slider {...settings}>
                          {data.items.map((obj, index) => {
                            let component = null;
                            switch (obj.tn) {
                              case 'ad':
                                component = (
                                  <RenderAds
                                    adObject={obj}
                                    noPlaceholder
                                    adWrapperClassname="col_l_4 col_m_4 adWrapperPlaceholder"
                                  />
                                );
                                break;
                              default:
                                if (obj.wu !== 'undefined' && obj.wu) {
                                  component = (
                                    <Link
                                      to={obj.wu}
                                      data-newga={
                                        obj.gaData ||
                                        `${gaAction}#${gaLabelPerfix}${index +
                                          1}/${obj.wu}`
                                      }
                                      target={
                                        obj.target === '_blank'
                                          ? obj.target
                                          : ''
                                      }
                                      aria-label={obj.hl}
                                      ga4Data={
                                        data?.ga4Type && [
                                          {
                                            event: 'user_click',
                                            type: `${data?.ga4Type}`,
                                            category: `${'story_click'}`,
                                            story_no: `${index + 1}`,
                                            msid: '',
                                          },
                                        ]
                                      }
                                    >
                                      <Image
                                        key={index}
                                        msid={obj.imageid}
                                        resizemode={4}
                                        imgsize={obj.imagesize}
                                        alt={obj.hl}
                                        width={ubannerWidth}
                                        title={obj.title || ''}
                                        placeHolderSrc="https://static.toiimg.com/photo/83033472.cms"
                                        lazyload={!doNotLazyLoadBanners}
                                      />
                                    </Link>
                                  );
                                } else {
                                  component = (
                                    // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                    <Link
                                      onClick={e => {
                                        e.preventDefault();
                                      }}
                                      className={s.fakeLink}
                                    >
                                      <Image
                                        key={index}
                                        msid={obj.imageid}
                                        resizemode={4}
                                        imgsize={obj.imagesize}
                                        alt={obj.hl}
                                        width={ubannerWidth}
                                        title={obj.title || ''}
                                        placeHolderSrc="https://static.toiimg.com/photo/83033472.cms"
                                        lazyload={!doNotLazyLoadBanners}
                                      />
                                    </Link>
                                  );
                                }
                            }
                            return component;
                          })}
                        </Slider>
                      </div>
                    </>
                  )}
                </div>
              </div>
              {data.border &&
                data.border === 'bottom' && <InterSectionBorder />}
            </>
          )}
      </InViewObserver>
    );
  }
}

const mapStateToProps = state => ({
  isMobile: state.isMobile,
});

BannerSlider.propTypes = {
  data: PropTypes.shape({}),
  bannerWidth: PropTypes.number,
  sliderSetting: PropTypes.shape({}),
  gaAction: PropTypes.string,
  gaLabelPerfix: PropTypes.string,
  onRendered: PropTypes.func,
  className: PropTypes.string,
  isMobile: PropTypes.bool,
};

BannerSlider.defaultProps = {
  data: {},
  bannerWidth: 368,
  sliderSetting: {},
  gaAction: '',
  gaLabelPerfix: '',
  onRendered() {},
  className: '',
  isMobile: false,
};
export default connect(mapStateToProps)(BannerSlider);
